import { ProductV2 } from '@common'

type RowLike<T extends { id: string } = ProductV2> = { product: T; quantity: number }
const rowToString = (row: RowLike) => `${row.product.id}:${row.quantity}`
export const compareCartRows = (a: RowLike[], b: RowLike[]) =>
  a.map(rowToString).join(';') !== b.map(rowToString).join(';')
